import React from 'react';
import { motion } from 'framer-motion';
import { manifestoData } from '../mockData';

const ManifestoSection = () => {
  return (
    <section className="py-32 bg-[#FAFAFA]" data-testid="manifesto-section">
      <div className="container mx-auto px-6">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-24 max-w-3xl mx-auto"
        >
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-[#1A1A1A] mb-6 tracking-tight">
            Our Approach
          </h2>
          <p className="text-lg md:text-xl text-gray-500 leading-relaxed">
            A methodology that combines timeless craftsmanship with modern innovation
          </p>
        </motion.div>

        {/* Manifesto Items */}
        <div className="max-w-5xl mx-auto space-y-24">
          {manifestoData.map((item, index) => (
            <motion.div
              key={item.number}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: index * 0.1 }}
              viewport={{ once: true, margin: '-100px' }}
              className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-start"
            >
              {/* Number */}
              <div className="lg:col-span-3">
                <span className="text-7xl md:text-8xl font-bold text-[#C8102E]/20 leading-none tracking-tight">
                  {item.number}
                </span>
              </div>

              {/* Content */}
              <div className="lg:col-span-9">
                <h3 className="text-3xl md:text-4xl font-bold text-[#1A1A1A] mb-4 tracking-tight">
                  {item.title}
                </h3>
                <p className="text-lg text-gray-500 leading-relaxed max-w-2xl">
                  {item.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ManifestoSection;
